import { render } from "./InvoiceStatusSettings.vue?vue&type=template&id=ba50f0d6&scoped=true&ts=true"
import script from "./InvoiceStatusSettings.vue?vue&type=script&lang=ts"
export * from "./InvoiceStatusSettings.vue?vue&type=script&lang=ts"

import "./InvoiceStatusSettings.vue?vue&type=style&index=0&id=ba50f0d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba50f0d6"]])

export default __exports__